import React from "react";
import Heading from "@insightfulscience/atomic-react/Heading";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";

import ErrorLayout from "./ErrorLayout";
import ErrorDetails from "./ErrorDetails";

function ErrorAccountReviewRequired({ error }: { error: object }) {
	return (
		<ErrorLayout extra={<ErrorDetails error={error} />}>
			<Heading
				Tag="h1"
				sx={{ fontSize: "xl", fontColor: "3", textAlign: "center" }}
				spacing={{ mb: 6 }}
			>
				We're reviewing your request
			</Heading>
			<Paragraph sx={{ fontSize: "s", textAlign: "center" }}>
				Please do not re-attempt this transaction until hearing back from us.
				<br />
				Rest assured, if this is a paid transaction, no charges have been
				submitted to your payment method.
			</Paragraph>
		</ErrorLayout>
	);
}

export default ErrorAccountReviewRequired;
